
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { RootState } from "../../store";
import { debugData } from "../../utils/debugData";
import { isEnvBrowser } from "../../utils/misc";
import { useSocketEventOutsideRequest } from "../../hooks/useSocketEventOutsideRequest";

import { UserState, SET_PLAYERDATA } from "../../reducers/userReducer";
import { PermissionType, PlayerType, HardMoneyState, SET_HOUSEDATA } from "../../reducers/hardmoneyReducer";
import { UIState, SET_activeTab, SET_hidden } from "../../reducers/uiReducer";

import UpgradeOption from "./UpgradeOption";

const UpgradesPage: React.FC = () => {
    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const playerData = useSelector((state: RootState) => state.user);
    const hardmoneyData = useSelector((state: RootState) => state.hardmoney);

    return (
        <div
            className="flexCenter"
            style={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                boxSizing: "border-box",
                position: "relative",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                flexDirection: "column",
                textAlign: "left",
               // backgroundColor: "yellow",
                gap: "5vh",
                padding: "3vh 0",
                color: "rgba(255, 255, 255, 0.9)",
               
            }}
        >
            <div
                style={{
                    //fontWeight: "bold",
                    fontSize: "6vh",
                    //backgroundColor: "orange",
                    fontFamily: 'Oswald',
                    fontWeight: "500",
                }}
            >
                Property Upgrades
            </div>

            <div
                style={{
                    width: "98%",
                    height: "60%",
                    //backgroundColor: "red",
                    display: "grid",
                    gridTemplateColumns: 'repeat(4, 1fr)',
                    gridTemplateRows: 'repeat(1, 1fr)',
                    //rowGap: "5vh",
                    columnGap: "2.5vh",
                }}
            >
                <UpgradeOption 
                    upgradeName={"storage"}
                />

                <UpgradeOption 
                    upgradeName={"garage"}
                />

                <UpgradeOption 
                    upgradeName={"security"}
                />

                <UpgradeOption 
                    upgradeName={"keys"}
                />
                
            </div>
        </div>
    );
};

export default UpgradesPage;
